<template>
    <v-dialog persistent  v-model="show"    max-width="1500px">
     
        <v-card > 
            <!-- <v-card-title class="headline layout justify-center red--text" >
                <h5>Buscador de Nota de Pedidos</h5>              
            </v-card-title> -->
            <v-btn
                icon
                color="black"
                @click="cancelarBuscadorMat"             
                style="position: absolute; top: 10px; right: 10px; z-index: 10;"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-row>
                <v-col cols="6" sm="6" md="6">
                    <v-radio-group v-model="flags" row dense>                       
                            <v-radio label="Buscar por NP" value="1"></v-radio>
                            <v-radio label="Buscar por Prov." value="2"></v-radio>
                            <v-radio label="Buscar por Destino" value="3"></v-radio>                            
                    </v-radio-group>  
                </v-col>
                <v-col cols="3" sm="3" md="3">                  
                    <v-card-title>
                        <v-text-field
                            v-model="search1"
                            append-icon="mdi-magnify"
                            label="Ingrese N° de NP"
                            single-line
                            hide-details                         
                            v-if="mostrar"  
                            @input="mayus(search1)"
                            @keypress.enter="nuevoFiltro(flags,'')"  
                            dense  
                        ></v-text-field> 

                        <v-text-field
                            v-model="search2"
                            append-icon="mdi-magnify"
                            label="Ingrese un nombre de Prov."
                            single-line
                            hide-details                           
                            v-if="mostrar1"                         
                            @input="mayus(search2)" 
                            @keypress.enter="nuevoFiltro(flags,'')"  
                            dense 
                            
                        ></v-text-field>
                        
                        <v-text-field
                            v-model="search3"
                            append-icon="mdi-magnify"
                            label="Ingrese destino np"
                            single-line
                            hide-details                           
                            v-if="mostrar2"                         
                            @input="mayus(search3)" 
                            @keypress.enter="nuevoFiltro(flags,'')"  
                            dense 
                            
                        ></v-text-field>
                    </v-card-title>
                </v-col>
                
            </v-row>     
           
            <!-- <v-card-actions>     
                <v-col class="headline layout justify-center">
                    <v-btn  x-small  color="red" @click="cancelarBuscadorMat" > Cancelar </v-btn>
                </v-col>                                       
                
            </v-card-actions>    -->
           
            <v-data-table 
                     v-if="mostrar"           
                    dense
                    :headers="headersNP"                     
                    class="elevation-1"                  
                    :items="desserts"  
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                       :search="search1"
                   
            
                >

                    <template v-slot:item.actions="{ item }"   >
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item,1)"
                            color="red"
                        >
                            mdi-check
                        </v-icon>                    
                                            
                    </template>   

                   

            </v-data-table> 
            
                    
          
            <v-data-table
                    v-if="mostrar1"
                    dense
                    :headers="headersNP1"
                    :items="desserts1"    
                    class="elevation-1"
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                       :search="search2"
                  
                   
                                   
                >
                    <template v-slot:item.actions="{ item }" >
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item,2)"
                                color="red"
                                
                                >
                                mdi-check
                                </v-icon>
                                
                    </template>  

            </v-data-table> 
            
            <v-data-table
                    v-if="mostrar2"
                    dense
                    :headers="headersNP2"
                    :items="desserts2"    
                    class="elevation-1"
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                    :search="search3"
                  
                   
                                   
                >
                    <template v-slot:item.actions="{ item }" >
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item,3)"
                                color="red"
                                
                                >
                                mdi-check
                                </v-icon>
                                
                    </template>  

            </v-data-table>
           
           
           
        </v-card>



        <v-dialog
            max-width="400"
            persistent
            v-model="cartel"
        >
            <v-card>
                <v-toolbar
                    color="primary"
                    dark
                    class="custom-toolbar"
                >
                    Registro en proceso
                </v-toolbar>
                <v-card-text>
                    <div class="text-h6 pa-2">Aguarde, consultando los datos..</div>
                </v-card-text>
            </v-card>
        </v-dialog>

    
    
    </v-dialog>    
    
    
   
        


</template>

<script>

import Axios from "../../../axios-auth-sistemas";
import moment from "moment";

export default {
    name:'BuscadorNotaPedido',
    data(){
        return{
            dialogMaterial: true,
            headersNP: 
                [
                        {text: 'Nota Pedido',value: 'np',  align: "left",sortable: true, filterable: true},
                        {text: 'Rev',value: 'rev',  align: "left",sortable: false },
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "left",sortable: false  },
                        {text: 'Fecha',value: 'fecha',  align: "left",sortable: false,filterable: false },
                        {text: 'Destino',value: 'destino',  align: "left",sortable: false,filterable: false },
                        {text: 'Prov',value: 'proveedor',  align: "left",sortable: false,filterable: false },
                       
                        
                ],
            headersNP1: 
                [
                        {text: 'Nota Pedido',value: 'np',  align: "left",sortable: false, filterable: false},
                        {text: 'Rev',value: 'rev',  align: "left",sortable: false },
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "left",sortable: false  },
                        {text: 'Fecha',value: 'fecha',  align: "left",sortable: false,filterable: false },
                        {text: 'Destino',value: 'destino',  align: "left",sortable: false,filterable: false },
                        {text: 'Prov',value: 'proveedor',  align: "left",sortable: true,filterable: true },
                       
                ],
            
            headersNP2: 
                [
                        {text: 'Nota Pedido',value: 'np',  align: "left",sortable: false, filterable: false},
                        {text: 'Rev',value: 'rev',  align: "left",sortable: false },
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "left",sortable: false  },
                        {text: 'Fecha',value: 'fecha',  align: "left",sortable: false,filterable: false },
                        {text: 'Destino',value: 'destino',  align: "left",sortable: true,filterable: true },
                        {text: 'Prov',value: 'proveedor',  align: "left",sortable: false,filterable: false },
                       
                ],    
             
                search1:'',
                search2:'',
                search3:'',

              
                desserts:[], 
                desserts1:[],
                desserts2:[], 
                mostrar:true,
                mostrar1:false,
                mostrar2:false,
                flags:"",
                editedIndex:-1,
                vSel:
                {
                    npedido:'',
                    
                        
                    
                },
                datos:[],
                itemsPerPage: 50, // Configura itemsPerPage en -1 para mostrar todos los elementos por defecto
                itemsPerPageOptions: [-1,10, 25, 50,75,100,200],

                cartel:false,
            
        }
    },
    props: ["visible", "flag"],


    computed: {
        show: {
           
            get() {      
                
               console.log("el flag seleccionado",this.flags)

               if (this.visible == true)
               {    

                   
                    if ( this.flags == "1") {
                        this.mostrar = true;
                        this.mostrar1 = false;
                        this.mostrar2 = false;
                        this.search1 = "";
                        this.search2 ="";
                        this.search3 ="";

                        
                       
                    }
                    if ( this.flags == "2") {
                    
                        this.mostrar = false;
                        this.mostrar1 = true;
                        this.mostrar2 = false;
                        this.search1 = "";
                        this.search2 ="";
                        this.search3 ="";                      
                        
                    }   
                    if ( this.flags == "3") {
                    
                        this.mostrar = false;
                        this.mostrar1 = false;
                        this.mostrar2 = true;
                        this.search1 = "";
                        this.search2 ="";
                        this.search3 ="";                      
                        
                    }
                    
                   

                }
                return this.visible;
            },
            

            set(value) {
               
                if (!value) {                   
                this.$refs.form.resetValidation();
                document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                this.$emit("close");
                }
            },
               
        },

     
    },

    mounted(){
      
        
       console.log("paso por el mounted")
        this.flags = "1"
        this.pflags = "1"
        if (this.desserts.length== 0 || this.desserts1.length==0)
                    {
                        this.mostrarDatos();
                    }

       
    },
    methods: {

        mostrarMensaje(item) {
      // Puedes mostrar un mensaje o realizar una acción aquí
        alert(`Presionaste Enter en la fila con el ID: ${item.id}`);
        },
        cancelarBuscadorMat(){
            this.flags="1"
            this.search1=""
            this.search2=""
            
            this.$emit("close");
        },

        mostrarDatos(deta){

          
            let self = this; 

            console.log("DETA", deta)

            if (deta == null || deta == "" || deta == undefined)
            {

                console.log("PASO POR DETA IS NULL", deta)

                if (this.flags == "1" || this.flags == "2" || this.flags == "3" )
                {

                        self.desserts = [];
                        self.desserts1 = [];
                        self.desserts2 = [];
                       
                        Axios              
                        .get("/Ti/NotaPedidoBuscador")
                        .then(r => {       

                            console.log("datosss", r.data)
                            
                           self.desserts= r.data;
                           self.desserts1= r.data;
                           self.desserts2= r.data;

                        

                                        
                        }).catch(r => {        
                                console.log("error en el mostrar las notas de pedido")
                                this.$swal("","Error en el buscador de orden de trabajo", "info")
                        });
                }  






               




            }            
              
            
            





           
        },

        

        mayus(e) {
                this.search1= this.search1.toUpperCase();
                this.search2= this.search2.toUpperCase();
                this.search3= this.search3.toUpperCase();
                

                //e.value = e.value.toUpperCase();
        },

        filterOnlyCapsText (value, search, item) {
           
            return value != null &&
                search != null &&
                typeof value === 'string' &&
                value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

        editItem(item,senal){
            if (senal == 1 ) {

                console.log(item)           
                this.editedIndex = this.desserts.indexOf(item)
                this.vSel = Object.assign({}, item)
                console.log(this.vSel.npedido)                                
                this.datos.npedido = this.vSel.npedido;  
                
                this.$emit('npSel', this.vSel.npedido)
               this.$emit("close");
               this.flags="1"
               this.search1=""
                this.search2=""
                this.search3=""
               
            }
            else
            if (senal == 2) 
            {
                console.log(item)           
                this.editedIndex = this.desserts1.indexOf(item)
                this.vSel = Object.assign({}, item)
                
              
                this.$emit('npSel', this.vSel.npedido)
                this.$emit("close");
                //this.$emit("close");
                this.flags="1"
                this.search1=""
                this.search2=""
                this.search3=""
                this.search4=""
            }else{



                if (senal == 3) 
                {
                    console.log(item)           
                    this.editedIndex = this.desserts2.indexOf(item)
                    this.vSel = Object.assign({}, item)
                    
                
                    this.$emit('npSel', this.vSel.npedido)
                    this.$emit("close");
                    //this.$emit("close");
                    this.flags="1"
                    this.search1=""
                    this.search2=""
                    this.search3=""
                    this.search4=""
                }

            }
            
        }, 

        limpiar(){

            this.search1="";
            this.search2="";
            this.search3="";

        },


        

        nuevoFiltro(opcion, id1)
        {

           
            // let self = this;    
            // if(opcion == 1)
            // {
               
            //     console.log("estoy en opcion 1")
            //     this.search2 = this.search2.toUpperCase(); 
            //     this.search4 = this.search4.toUpperCase(); 
            //     this.search5 ="";
            //     let id = this.search2;
            //     self.dessertsMat1 =[];

            //     console.log("id1", id1)

            //     if(id1 == null || id1 == undefined || id1 == "")
            //     {
            //         id1= "";
            //     }
                
            //     self.cartel =true;
            //     Axios
            //     .get("/CtaOtPro/NuevoFiltroOT?", {
            //     params: {
            //         id: id,
            //         id1: id1,
            //         id2: '1',
            //     },
            //     })   
            //     .then(r => {           
                    
                    
                  
            //         r.data.forEach(element => {

            //         const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

            //         self.dessertsMat1.push({
            //             otrabajo: element.otrabajo,
            //             detalle: element.detalle,                    
            //             fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
            //             taller: element.taller
            //         })

            //         self.cartel =false;
                    
            //     })   

            //     self.cartel =false;
                                
            //     }).catch(r => {        
                  
            //             this.$swal("","Error en el buscador de orden de trabajo", "info")
            //             self.cartel =false;
            //     });


            // }



            // if(opcion == 2)
            // {

            //     console.log("estoy en opcion 2")
            //     this.search1 = this.search1.toUpperCase(); 
            //     this.search4 = this.search4.toUpperCase(); 
            //     let id = this.search1;
            //     this.search5 ="";
            //     self.dessertsMat=[];
            //     self.cartel =true;
            //     Axios
            //     .get("/CtaOtPro/NuevoFiltroOT?", {
            //     params: {
            //         id: id,
            //         id1: id1,
            //         id2: '2',
            //     },
            //     })   
            //     .then(r => {           
                    
                    
                  
            //         r.data.forEach(element => {

            //         const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

            //         self.dessertsMat.push({
            //             otrabajo: element.otrabajo,
            //             detalle: element.detalle,                    
            //             fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
            //             taller: element.taller
            //         })

            //         self.cartel =false;
                    
            //     })   

            //     self.cartel =false;
                                
            //     }).catch(r => {        
                     
            //             this.$swal("","Error en el buscador de orden de trabajo", "info");
            //             self.cartel =false;
            //     });


            // }

            // if(opcion == 3)
            // {

               
            //     console.log("estoy en opcion 3")
            //     this.search3 = this.search3.toUpperCase(); 
            //     let id = this.search3;
              
            //     console.log(id) 
               
            //     this.search4 = this.search4.toUpperCase(); 
            //     this.search5 ="";
              
            //     self.dessertsMat2=[];
            //     self.cartel =true;
            //     Axios
            //     .get("/CtaOtPro/NuevoFiltroOT?", {
            //     params: {
            //         id: id,
            //         id1: id1,
            //         id2: '3',
            //     },
            //     })   
            //     .then(r => {         
                    
                    
                                        

            //             r.data.forEach(element => {

            //                 const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

            //                 self.dessertsMat2.push({

            //                     otrabajoit: element.otrabajoit,
            //                     detalle: element.detalle,
            //                     // fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
            //                     fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
            //                     taller: element.taller,
            //                     otrabajo: element.otrabajo,
            //                 })

            //                 self.cartel =false;


            //             }) 
                        
            //             console.log( "fin")
            //             self.cartel =false;
                        
            //     }).catch(r => {        
                     
            //             this.$swal("","Error en el buscador de orden de trabajo", "info");
            //             self.cartel =false;
            //     });

            // }



            // if(opcion == 5)
            // {

               
            //     console.log("estoy en opcion 5")
            //     this.search1 ="";
            //     this.search2 ="";
            //     this.search3 ="";
            //     this.search5 = this.search5.toUpperCase(); 
              
              
               
               
             
               
            //     self.cartel =true;
            //     self.dessertsMat5=[];
                
            //     Axios
            //     .get("/CtaOtPro/NuevoFiltroOT?", {
            //     params: {
            //         id: this.search5 ,
            //         id1: '1',
            //         id2: '5',
            //     },
            //     })   
            //     .then(r => {         
                    
                    
            //            console.log(r.data)     

            //           // self.dessertsMat5 = r.data;               

            //             r.data.forEach(element => {

            //                 const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

            //                 self.dessertsMat5.push({

            //                     otrabajoit: element.otrabajoit,
            //                     detalle: element.detalle,
            //                     // fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
            //                     fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
            //                     taller: element.taller,
            //                     otrabajo: element.otrabajo,
            //                 })


            //              }) 
                        
            //             console.log( "fin")

            //             self.cartel=false;
                        
            //     }).catch(r => {        
                     
            //             this.$swal("","Error en el buscador de orden de trabajo", "info")
            //             self.cartel=false;
            //     });

            // }

        },

       

    },
}
</script> 


 



 

 
